import React, { useState, useRef, useLayoutEffect, useEffect } from "react";

/** Components */
import {
  Button,
  TablePagination,
  Paper,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableFooter,
  Collapse,
  ButtonGroup,
  Dialog,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { TreeMenu } from "../../commons/renderTreeMenu.component";
import { FilterBy } from "../../commons/filter.component";
import InvoiceDetail from "./invDetail";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";

/** Api & Function */
import { getCustomers, getInvoiceMenu, getInvoices, getUsers } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { convertQueryStringToObject, updateNode } from "../../../services/libService";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { InvStatusOption, SEARCH_INV, statusColor } from "../../config";
import { useParamFilter } from "../../commons/customHook";
import { ClickAwayListener, MenuList, Popper } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function Invoices() {
  const [t] = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [isSearchOpen, setSearchOpen] = useState(true);
  const user = useSelector((state) => state.user.data);
  // custom hook
  const location = useLocation();
  const { invoiceId } = useParams();
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter(
    { type: "NAPR", page: 1, per_page: 50, organization_id: user?.organization_id },
    getInvoices
  );
  const filter = convertQueryStringToObject(location.search);

  const [input, setInput] = useState({
    selectedCustomer: null,
    code: filter.code || null,
    start_date: filter.start_date || null,
    end_date: filter.end_date || null,
    selectedUser: null,
    year: null,
  });
  const [treeData, setTreeData] = useState();

  const handleRowClick = (e, id) => {
    history.push(`/invoices/${id}${location.search}`);
  };
  const xem_pdf = (e, id) => {
    e.stopPropagation();
    history.push({ pathname: `/invoices/${id}`, search: location.search, state: { tab: 1 } });
  };
  const handleUpdate = (res, newItem) => {
    if (res.code === 200) {
      // eslint-disable-next-line eqeqeq
      setData((prev) => updateNode(prev, (data) => data.map((item) => (item.id == newItem.id ? { ...newItem, prd_l15: newItem.invoiceproducts?.[0]?.l15 } : item))));
    }
  };
  const handleSearch = () => {
    fetchData((prev) => ({
      ...input,
      type: "ALL",
      selectedCustomer: undefined,
      customer_id: input.selectedCustomer?.id,
      staff_id: input.selectedUser?.id,
      selectedUser: null,
      status: input.status?.action,
    }));
    getInvoiceMenu({ type: "ALL" }).then((res) => {
      setTreeData(res.data);
    });
  };
  const handleChangeTab = (e) => {
    setInput({
      selectedCustomer: null,
      code: null,
      fkey: null,
      start_date: null,
      end_date: null,
      year: null,
    });
    fetchData((prev) => ({ type: e.target.value }));
    setTreeData(null);
    getInvoiceMenu({ type: e.target.value }).then((res) => {
      setTreeData(res.data);
    });
  };
  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    getInvoiceMenu({ type: filter.type }).then((res) => {
      setTreeData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN HOÁ ĐƠN GIÁ TRỊ GIA TĂNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div style={{ justifyContent: "space-between", display: "flex", backgroundColor: "#b3deff", marginBottom: 20, marginTop: 10, height: 40 }}>
        <Select style={{ height: 40, marginLeft: 5 }} value={filter.type || "ALL"} onChange={handleChangeTab}>
          {Object.keys(SEARCH_INV).map((item) => (
            <MenuItem key={item} value={item}>
              {t(SEARCH_INV[item].code)}
            </MenuItem>
          ))}
          <MenuItem style={{ display: "none" }} value="ALL">
            Tìm kiếm hóa đơn
          </MenuItem>
        </Select>
        <ButtonGroup style={{ marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
          <DropdownActions />
        </ButtonGroup>
      </div>
      <div>
        <Collapse in={isSearchOpen}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label={t("Số hóa đơn")}
            value={input.code || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value || null }))}
            style={{ margin: "5px" }}
            InputProps={{ style: { minWidth: "80px", maxWidth: "120px" } }}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.selectedCustomer || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedCustomer: newValue }))}
            label={t("Khách hàng")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, selectedCustomer: option.find((item) => item.id == filter.customer_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.customer_id]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
            getDataFunc={() => getUsers({ organization_id: user?.organization_id })}
            value={input.selectedUser || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedUser: newValue }))}
            label={t("Người phát hành")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, selectedUser: option.find((item) => item.id == filter.staff_id) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.staff_id]}
          />

          <CustomDatePicker label={t("Từ ngày")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <CustomDatePicker label={t("Đến ngày")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ minWidth: "200px", margin: "5px" }} />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
            label={t("Trạng thái")}
            getOptionLabel={(option) => t(option.label)}
            isOptionEqualToValue={(option, value) => option === value}
            getDataFunc={() => Promise.resolve({ data: InvStatusOption, code: 200 })}
            value={input?.status || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((item) => item.action == filter.status) }))}
            triggerSetDefaultFunc={true}
            setDefaultDependencies={[filter.status]}
          />
          {/* <DatePicker
            label={t("Năm phát hành")}
            InputLabelProps={{ shrink: true }}
            format="YYYY"
            views={["year"]}
            defaultValue={input.year ? dayjs(input.year) : null}
            onChange={(value) => {
              const year = value ? dayjs(value).format("YYYY") : null;
              setInput((prev) => ({ ...prev, year: year }));
            }}
            sx={{ minWidth: "80px", maxWidth: "200px", margin: "5px" }}
          /> */}
          <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
            {t("Tìm kiếm")}
          </Button>
        </Collapse>
        <div style={{ display: "flex" }}>
          <TreeMenu
            data={treeData}
            onClick={(query) => {
              fetchData((prev) => ({ ...query, type: prev.type, per_page: prev.per_page }));
              setInput({});
            }}
            isExpand={!isSearchOpen}
            onExpand={() => setSearchOpen(false)}
          />
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "100%" }}>
              <Table>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                      ID
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Ký hiệu")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Số hóa đơn")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Mã tra cứu")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("ERP Code")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Loại")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Tên khách hàng")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                      USG
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                      Lit
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                      L15
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Ngày chứng từ")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Người phát hành")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Điểm bán")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Trạng thái")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="center" padding="checkbox">
                      {t("Hành động")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow hover style={{ cursor: "pointer", backgroundColor: invoiceId === item.id ? "lightgray" : "" }} key={index} onClick={(e) => handleRowClick(e, item.id)}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.serial}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left" padding="checkbox">
                          {item.code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.fkey}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.erp_code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.component}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left" padding="checkbox">
                          {item.customer_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {Math.round(item.sub_gallon)?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {Math.round(item.sub_lit)?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {Math.round(item.prd_l15)?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left" padding="checkbox">
                          {item.deliver_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          {item.sale_area}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox">
                          <div className={`status ${item.status}`} style={{ color: statusColor[item.status], whiteSpace: "nowrap" }}>
                            {t(item.status)}
                          </div>
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center" padding="checkbox" onClick={(e) => xem_pdf(e, item.id)}>
                          <PictureAsPdfIcon color="primary" />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" padding="checkbox" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
        <Detail key={invoiceId} id={invoiceId} onClose={() => history.push(`/invoices${location.search}`)} onUpdate={handleUpdate} />
      </div>
    </div>
  );
}

const Detail = ({ id, onClose, onUpdate }) => {
  return (
    <Dialog open={Boolean(id)} onClose={onClose} maxWidth={false} fullWidth>
      <div align="center" padding="checkbox" style={{ padding: 10, height: "100vh" }}>
        <InvoiceDetail invoiceid={id} onClose={onClose} onUpdate={onUpdate} />
      </div>
    </Dialog>
  );
};
const DropdownActions = ({ ...buttonProps }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const [t] = useTranslation();
  return (
    <React.Fragment>
      <Button ref={ref} {...buttonProps} onClick={() => setOpen((prev) => !prev)}>
        <MoreVertIcon />
      </Button>
      <Popper style={{ zIndex: 1000 }} open={open} anchorEl={ref.current}>
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper>
            <MenuList>
              <MenuItem onClick={() => history.push("/invoices/create/airinv")}>{t("Tạo hóa đơn sân bay")}</MenuItem>
              <MenuItem onClick={() => history.push("invoices/create/truck")}>{t("Tạo hóa đơn nội địa xe bồn")}</MenuItem>
              <MenuItem onClick={() => history.push("invoices/create/ship")}>{t("Tạo hóa đơn tái xuất tàu thủy")}</MenuItem>
              <MenuItem onClick={() => history.push("invoices/create/other")}>{t("Tạo hóa đơn khác")}</MenuItem>
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </React.Fragment>
  );
};
